import React from "react";
import { Link } from 'react-router-dom';

export default ({ bounds, visible, hidden=false, popup_ref, session, onEndSession }) => {

  const { uid, logged_out } = session;

  const position = (bounds.left || 0) - 85;

  const display = `${!visible ? 'none' : 'block'}`;

  const authenticated = (!!uid && logged_out!==true);

  const css_style = { left: position, display: display };

  return (
    <div ref={popup_ref} className={`Account-List ${hidden}`} style={css_style}>

      <div className="Category-Wrapper">

        { (!authenticated) &&
          <Link className='Category' to={`/login`}>Login</Link>
        }

        { (!authenticated) &&
          <Link className='Category' to={`/signup`}>Create Account</Link>
        }

        { (!!authenticated) &&
          <Link className='Category' to={`/account/profile`}>My Account</Link>
        }

        <Link className='Category' to={`/account/orders`}>My Orders</Link>

        <Link className='Category' to={`/account/history`}>Recently Viewed</Link>

        <Link className='Category' to={`/account/reviews`}>Write a Review</Link>

        <Link className='Category' to={`/help`}>Help Center</Link>

        { (!!authenticated) &&
          <div className='Category' onClick={onEndSession}>Sign Out</div>
        }

      </div>
    </div>
  )

};
